/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Failedtoendliveroom4Inputs */

const en_failedtoendliveroom4 = /** @type {(inputs: Failedtoendliveroom4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The Live Room could not be ended.`)
};

const de_failedtoendliveroom4 = /** @type {(inputs: Failedtoendliveroom4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Der Live Room konnte nicht beendet werden.`)
};

/**
* | output |
* | --- |
* | "The Live Room could not be ended." |
*
* @param {Failedtoendliveroom4Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const failedtoendliveroom4 = /** @type {((inputs?: Failedtoendliveroom4Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Failedtoendliveroom4Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_failedtoendliveroom4(inputs)
	return de_failedtoendliveroom4(inputs)
});
export { failedtoendliveroom4 as "failedToEndLiveRoom" }